exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-check a.show {\n    cursor: pointer;\n}\n.form-check a.show:hover {\n    text-decoration: underline;\n}\n", ""]);

// exports
